// @flow
import { useMutation, type MutationResult } from 'react-query';

import { productSettings as productSettingsApi } from 'platform/api';
import queryClient from 'common/middleware/queryClient';

import { toApiProduct } from './utils';

type Variables = {
    clientId: string,
    settings: $FixMe,
    version: number,
    product: string
};

export default function useUpdateProductSettings(): MutationResult<
    Variables,
    void
> {
    return useMutation<Variables, void>(
        ({ clientId, settings, product, version }) => {
            return productSettingsApi.post(
                { clientId, product: toApiProduct(product) },
                { settings, version }
            );
        },
        {
            onSuccess: (response, { product }) => {
                // NOTE: BE has cache enabled for get api,
                // read api can return stale data if triggered just after update
                // But in response it always sends the new value, using that instead to update role
                const key = ['product', product, 'settings'];
                const currentProduct = queryClient.getQueryData(key);
                queryClient.setQueryData(key, {
                    ...currentProduct,
                    ...response
                });
            }
        }
    );
}
